import React, { useState } from 'react';
import { FaUserTie } from 'react-icons/fa';

const DirectorsCard = ({ name, charge, profession, image, width }) => {
    const [imgError, setImgError] = useState(false);
    const [isPadded, setIsPadded] = useState(false);

    // Limpieza de profesión/contenido (Strapi a veces trae solo un punto "." o espacios vacíos)
    const hasProfession = profession && profession.trim() !== '.' && profession.trim() !== '';
    const cleanProfession = hasProfession
        ? profession.trim()
        : 'Miembro del Consejo Directivo del Colegio Secundaria Babeque.';

    const handleImageLoad = (e) => {
        const { naturalWidth, naturalHeight } = e.target;
        // Las imágenes PNG de 1080x1080 fueron subidas con un lienzo/margen vacío al 50%.
        // Detectamos esa plantilla para calibrar el zoom y emparejar la escala con el resto del consejo.
        if (naturalWidth === 1080 && naturalHeight === 1080) {
            setIsPadded(true);
        }
    };

    return (
        <div style={{ width: width }} className="directors-card">
            <div className="card-inner">
                {/* Columna Izquierda: Fotografía Estandarizada */}
                <div className="card-media-col">
                    <div className="card-image-wrapper">
                        {image && !imgError ? (
                            <img
                                src={image}
                                alt={`Fotografía de ${name || 'Miembro del Consejo'}`}
                                className={`directors-photo ${isPadded ? 'directors-photo--padded' : ''}`}
                                onLoad={handleImageLoad}
                                onError={() => setImgError(true)}
                                loading="lazy"
                            />
                        ) : (
                            <div className="directors-photo-placeholder">
                                <FaUserTie className="placeholder-icon" />
                                <span>Secundaria Babeque</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Columna Derecha: Información Contigua */}
                <div className="card-right">
                    {charge && (
                        <div className="card-charge-badge">
                            {charge}
                        </div>
                    )}
                    <h3 className="card-name">
                        {name}
                    </h3>
                    <div className="card-accent-line"></div>
                    <div className="info-profession">
                        {cleanProfession}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DirectorsCard;